import { useEffect } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { SidebarProvider, SidebarTrigger } from '@/components/ui/sidebar';
import { Separator } from '@/components/ui/separator';
import { AppSidebar } from '@/components/AppSidebar';
import AppBreadcrumb from '@/components/AppBreadcrumb';
import TopbarOptions from '@/components/TopbarOptions';
import WebappChatUI from './WebappChatUI';
import UserViewContextProvider from './UserViewContext';
import rememberLastAgentId from '@/helpers/lastAgentId/rememberLastAgentId';
import { Topbar, MainContent } from './styled';

interface LayoutProps {
    children?: React.ReactNode;
}

function Layout({ children }: LayoutProps) {
    const { agentId } = useParams();

    useEffect(() => {
        if (agentId) {
            rememberLastAgentId({ agentId });
        }
    }, [agentId]);

    return (
        <SidebarProvider>
            <UserViewContextProvider>
                <div className="flex h-screen w-full">
                    <AppSidebar />
                    <main className="flex flex-col flex-1 overflow-hidden">
                        <Topbar>
                            <SidebarTrigger />
                            <Separator orientation="vertical" className="!h-6" />
                            <AppBreadcrumb />
                            <div className="ml-auto flex items-center gap-2">
                                <TopbarOptions />
                                <WebappChatUI />
                            </div>
                        </Topbar>
                        <MainContent>{children || <Outlet />}</MainContent>
                    </main>
                </div>
            </UserViewContextProvider>
        </SidebarProvider>
    );
}

export default Layout;
